
<div id="app">
  <Navigation
    :key="editorKey"
    :view="view"
    v-show="showNav"
    id="navigation"
  />
  <div @dblclick="dbclick()">
    <Settings v-show="view == 'settings'" />
    <TextView
      @click="focusText()"
      v-show="view == 'tabula'"
      :key="editorKey"
      :nav="showNav"
      :chat="showChat"
      ref="tabula"
    />
  </div>
  <Chat :nav="showNav" ref="chat" />
</div>
